export const NEARBY_PROJECTS_REQUEST = 'NEARBY_PROJECTS_REQUEST';
export const NEARBY_PROJECTS_SUCCESS = 'NEARBY_PROJECTS_SUCCESS';
export const NEARBY_PROJECTS_FAIL = 'NEARBY_PROJECTS_FAIL';

export const GET_ALL_PROJECTS_REQUEST = 'GET_ALL_PROJECTS_REQUEST';
export const GET_ALL_PROJECTS_SUCCESS = 'GET_ALL_PROJECTS_SUCCESS';
export const GET_ALL_PROJECTS_FAIL = 'GET_ALL_PROJECTS_FAIL';

export const ADD_COMMENT_REQUEST = 'ADD_COMMENT_REQUEST';
export const ADD_COMMENT_SUCCESS = 'ADD_COMMENT_SUCCESS';
export const ADD_COMMENT_FAIL = 'ADD_COMMENT_FAIL';
